import moment from "moment";

const formats = {
    server: "YYYY-MM-DD",
    br: "DD/MM/YYYY",
    hourServer: "HH:mm:ss",
    hour: "HH:mm",
};

export default {
    install(Vue) {
        Vue.prototype.$date = Vue.date = this;
    },

    format(date) {
        return moment(date, formats.server).format(formats.br);
    },

    formatDateAndHour(date) {
        return moment(date).format(`${formats.br} - ${formats.hour}`);
    },

    formatHour(hour) {
        return moment(hour, formats.hourServer).format(formats.hour);
    },

    parse(date) {
        return moment(date, formats.br).format(formats.server);
    },

    timestamp() {
        return moment().valueOf();
    },
};
